import { ActiveWorkflowsBySpace } from "./ActiveWorkflowsBySpace";
import { AutofixAutotunePanel } from "./AutofixAutotunePanel";
import { DuplicateWorkflowsPanel } from "./DuplicateWorkflowsPanel";
import { ExecutionsBySpace } from "./ExecutionsBySpace";
import { FailingWorkflowsPanel } from "./FailingWorkflowsPanel";
import { MonitoringLayout } from "./MonitoringLayout";
import { MonitoringScopeSelector } from "./MonitoringScopeSelector";
import { RouteAuthPanel } from "./RouteAuthPanel";
import { routes } from "../../lib/urls";
import { useHasAccess } from "../../hooks/useHasAccess";
import { StorageBySpace } from "./StorageBySpace";
import { TinesUnitsPanel } from "./TinesUnitsPanel";
import { WorkflowDependenciesPanel } from "./WorkflowDependenciesPanel";
import {
  SideStack,
  SideStackPair,
  WorkflowsGrid,
  WorkflowsShell,
} from "./workflowsLayout";

export function Workflows() {
  // The units gauge mixes per-space stats with tenant-wide network usage, so
  // it only renders for viewers whose reads cover every space — otherwise the
  // inputs would cover different subsets and the total would be misleading.
  const canReadAllSpaces = useHasAccess("tenant:spaces_read");
  return (
    <MonitoringLayout
      headerItem={
        <MonitoringScopeSelector route={routes.monitoring.workflows} />
      }
    >
      <WorkflowsShell>
        {canReadAllSpaces && <TinesUnitsPanel />}
        <WorkflowsGrid>
          <ActiveWorkflowsBySpace />
          <ExecutionsBySpace />
          <StorageBySpace />
          <RouteAuthPanel />
          <SideStack>
            <FailingWorkflowsPanel />
            <DuplicateWorkflowsPanel />
            <SideStackPair>
              <AutofixAutotunePanel />
              <WorkflowDependenciesPanel />
            </SideStackPair>
          </SideStack>
        </WorkflowsGrid>
      </WorkflowsShell>
    </MonitoringLayout>
  );
}
